'use client';

import Image from 'next/image';
import React from 'react';

import {
    Box,
    BoxContent,
    BoxHeader,
    Button,
    ButtonVariant,
    Column,
    Columns,
    DirectionEnum,
    FlexBox,
    FlexItem,
    GapSize,
    Icon,
    IconName,
    IconSize,
    Justify,
    Price,
    Row,
    Rows,
    Spacer,
    SpacerSize,
    Text,
    TextLevels,
    Title,
    TitleLevels,
    TypographyAlign,
    TypographyBold,
    View,
} from '@bytel/trilogy-react';

import { getAppConfig } from '@services/config';

const config = getAppConfig();

export function OfferSkeleton() {
    return (
        <Rows gap={10}>
            <Row>
                <Title level={TitleLevels.THREE} typo={TypographyAlign.TEXT_CENTERED}>
                    Vos forfaits préférés
                </Title>
                <FlexBox wrap justify={Justify.CENTER}>
                    <OfferCardContainerSkeleton />
                    <OfferCardContainerSkeleton />
                    <OfferCardContainerSkeleton />
                </FlexBox>
            </Row>
            <Row className='has-text-centered'>
                <Title level={TitleLevels.THREE} typo={TypographyAlign.TEXT_CENTERED}>
                    Tous les forfaits
                </Title>
                <FlexBox wrap justify={Justify.CENTER}>
                    <OfferCardContainerSkeleton />
                    <OfferCardContainerSkeleton />
                </FlexBox>
                <Spacer size={SpacerSize.FIVE} />
                <Button variant={ButtonVariant.PRIMARY} disabled>
                    <Icon name={IconName.ARROW_DOWN} />
                    Voir tous les forfaits
                </Button>
            </Row>
        </Rows>
    );
}

export function OfferCardContainerSkeleton({
    isCurrent = false,
    withPhone = false,
}: {
    isCurrent?: boolean;
    withPhone?: boolean;
}) {
    return (
        <FlexItem size={{ tablet: 6, desktop: 6, widescreen: 4 }}>
            <FlexBox direction={DirectionEnum.COLUMN} fullheight>
                {withPhone && (
                    <>
                        <Box className='is-loading'>
                            <Columns>
                                <Column narrow className='is-flex'>
                                    <Image
                                        src={`${config.assets.cmsImages.url}/original/image/CMS/ecommerce/wall/lazyload-phone-default-image.svg`}
                                        alt=''
                                        width={55}
                                        height={110}
                                    />
                                </Column>
                                <Column className='has-text-centered-mobile'>
                                    <div>
                                        <Text typo={TypographyBold.TEXT_WEIGHT_SEMIBOLD} level={TextLevels.FOUR}>
                                            Lorem ipsum in
                                        </Text>
                                    </div>
                                    <Text style={{ fontSize: '24px' }}>Lorem</Text>
                                    <Spacer size={SpacerSize.FIVE} />
                                </Column>
                            </Columns>
                        </Box>
                        <View flexable fullwidth className='is-centered'>
                            <Icon size={IconSize.SMALL} name={IconName.PLUS_CIRCLE} />
                        </View>
                    </>
                )}
                <div>
                    <Box shadowless fullheight headerOffset={!isCurrent}>
                        {isCurrent && (
                            <BoxHeader className='is-justified-center'>
                                <Text level={TextLevels.ONE} marginless typo={TypographyAlign.TEXT_CENTERED}>
                                    Mon forfait actuel
                                </Text>
                            </BoxHeader>
                        )}
                        <BoxContent className='has-text-left'>
                            <FlexBox
                                direction={DirectionEnum.COLUMN}
                                justify={Justify.SPACE_BETWEEN}
                                fullheight
                                gap={{ mobile: GapSize.ONE }}
                            >
                                <FlexItem>
                                    <FlexBox
                                        direction={DirectionEnum.COLUMN}
                                        gap={{ mobile: GapSize.THREE, desktop: GapSize.FIVE }}
                                    >
                                        <FlexBox direction={DirectionEnum.COLUMN} gap={GapSize.FIVE}>
                                            <FlexBox direction={DirectionEnum.COLUMN} gap={GapSize.SEVEN}>
                                                <FlexItem narrow>
                                                    <Title level={TitleLevels.THREE} marginless inverted>
                                                        Lorem ips
                                                    </Title>
                                                    <Title level={TitleLevels.FIVE} marginless inverted>
                                                        Lorem ip
                                                    </Title>
                                                </FlexItem>
                                                <FlexBox direction={DirectionEnum.COLUMN} gap={GapSize.FOUR}>
                                                    <Price amount={0} inverted />
                                                    <Text level={TextLevels.TWO} inverted>
                                                        &nbsp;
                                                    </Text>
                                                    <Spacer size='50' />
                                                </FlexBox>
                                            </FlexBox>
                                        </FlexBox>
                                        <Button type='button' variant={ButtonVariant.CONVERSION} fullwidth disabled>
                                            Continuer avec ce forfait
                                        </Button>
                                        {/* Pépites placeholder */}
                                        <Spacer size='121' />
                                    </FlexBox>
                                </FlexItem>
                                <FlexItem>
                                    <FlexBox
                                        direction={DirectionEnum.COLUMN}
                                        justify={Justify.END}
                                        gap={GapSize.FIVE}
                                        fullheight
                                    >
                                        <Button type='button' variant={ButtonVariant.GHOST} fullwidth>
                                            Voir les détails
                                        </Button>
                                        <Text level={TextLevels.THREE} inverted marginless>
                                            C&apos;est moins chère que gratuit
                                        </Text>
                                    </FlexBox>
                                </FlexItem>
                            </FlexBox>
                        </BoxContent>
                    </Box>
                </div>
            </FlexBox>
        </FlexItem>
    );
}
